import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Add any additional global styles here */

  main {
    padding: 0 150px;
    margin: 0 auto;
    width: 100%;
    max-width: 1600px;
    min-height: 100vh;
  }

  section {
    margin: 0 auto;
    padding: 100px 0;
    max-width: 1000px;
  }
`;

export default GlobalStyle;